import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

import {
  roofTypeGambrelIcon, roofTypeHipIcon, roofTypeTentedIcon, roofTypeMultiPitchIcon, roofTypeGableIcon,
  roofTypeLamonteraGambrel, roofTypeLamonteraHip, roofTypeLamonteraTented, roofTypeLamonteraMultiPitch, roofTypeLamonteraGable,
} from 'src/assets/images';

import { StepType } from "src/store/RoofStoreModule";
import { RoofType } from "src/store/roofData/types";
import { getRoofImage } from "src/components/Roof/utils/getRoofImage";

interface Roof {
  id: number;
  type: RoofType;
  img: string;
  imgBig: string;
  label: string;
}

export const roofCards: Roof[] = [
  {
    id: 1,
    type: 'gambrel',
    img: roofTypeGambrelIcon,
    imgBig: roofTypeLamonteraGambrel,
    label: 'Мансардная',
  },
  {
    id: 2,
    type: 'hip',
    img: roofTypeHipIcon,
    imgBig: roofTypeLamonteraHip,
    label: 'Вальмовая',
  },
  {
    id: 3,
    type: 'tented',
    img: roofTypeTentedIcon,
    imgBig: roofTypeLamonteraTented,
    label: 'Шатровая',
  },
  {
    id: 4,
    type: 'multipitch',
    img: roofTypeMultiPitchIcon,
    imgBig: roofTypeLamonteraMultiPitch,
    label: 'Многоскатная',
  },
  {
    id: 5,
    type: 'gable',
    img: roofTypeGableIcon,
    imgBig: roofTypeLamonteraGable,
    label: 'Двускатная',
  },
];

export const usePresenter = () => {
  const { dispatch, roofStore } = useStoreon<IState, IEvents>('roofStore');

  const roofImg = getRoofImage(
    roofStore.profileType,
    roofStore.metalTileName,
    roofStore.pailingName,
    roofStore.roofType,
  );

  const chooseRoofType = (type: RoofType) => {
    if (roofStore.roofType !== type) {
      dispatch('roof/set-roof-type', { value: type });
      dispatch('roof/set-L_kr-value', { value: null });
      dispatch('roof/set-L_k-value', { value: null });
      dispatch('roof/set-B_kr-value', { value: null });
      dispatch('roof/set-B_kr1-value', { value: null });
      dispatch('roof/set-B_kr2-value', { value: null });
      dispatch('roof/set-H_p1-value', { value: null });
      dispatch('roof/set-H_p2-value', { value: null });
    }

    dispatch('roof/set-stepID', { stepID: ((roofStore.stepID + 1) as StepType) });
  };

  const focusedField = roofStore.focusedField;
  const roofType = roofStore.roofType

  return {
    roofCards,
    activeRoof: roofStore.roofType,
    chooseRoofType,
    roofImg,
    focusedField,
    roofType,
  };
};
